import {extend} from 'flarum/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import Button from 'flarum/components/Button';
import app from 'flarum/forum/app';
import JumpToMidModal from "./components/JumpToMidModal";

app.initializers.add('annonny-flarum-jump-to-mid', () => {
  extend(IndexPage.prototype, 'sidebarItems', function (items) {
    const routeName = app.current.get('routeName');
    let itemName = "forum-jumptomid";

    if (routeName === "tag") {
        itemName = "forum-jumptomid-1";
    }

    items.add(itemName, Button.component({
      icon: 'fas fa-m',
      className: 'Button JumpToMidButton',
      itemClassName: 'App-primaryControl',
      id: "JumpToMidButton",
      onclick: () => {
        app.modal.show(JumpToMidModal)
      }
    }, "跳转Mid"),50);

  });
});
